module.exports = __webpack_public_path__ + "static/media/Thirty.43329c9b.ogg";